import { Types } from '@store/types';

const initialState = false;

const LoaderReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.CLOSE_LOADER:
		case Types.OPEN_LOADER:
			return action.payload;
		default:
			return state;
	}
};

export default LoaderReducer;
